import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { urlValidation } from "../../../../CloudStorage/CommonFunction";
import CustomReactQuill2 from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill2";
import CompanyFileUpload from "../../ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";

export default function ProfileModelCompanyAbout({
  edittype,
  formData,
  setFormData,
  setModelCompanyAbout,
}) {
  const [country, setCountry] = useState([]);
  const [selectCountry, setSelectCountry] = useState(null);
  const [im, setIm] = useState(formData?.iam || 1);
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);
  const dispatch = useDispatch();

  const initialValues = {
    company_name:
      formData?.company?.company_name || formData?.company_name || "",
    cr_number: formData?.company?.cr_number || formData?.cr_number || "",
    website_link:
      formData?.company?.website_link || formData?.website_link || "",
    about_files: formData?.company?.about_files || formData?.about_files || [],
    about: formData?.company?.about || formData?.about || "",
    country_id: formData?.company?.country_id || formData?.country_id || "",
  };

  const validationSchema = Yup.object().shape({
    company_name: titlevalidation,
    cr_number: Yup.string()
      .trim()
      .required("This field is required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    about_files: Yup
      .array()
      .of(
        Yup.object().shape({
          file: Yup.string().url().required("File URL is required"),
        })
      )
      .test(
        "at-least-one-file",
        "At least one file is required",
        (value) => Array.isArray(value) && value.length > 0
      ),
    country_id: Yup.string()
      .trim()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    // wathq_verification: Yup.string().trim().required('This field is required').test('not-only-spaces', 'Please enter a valid value', value => value.trim() !== ''),
    about: descriptionvalidation,
    website_link: Yup.string()
      .required("Website Link is Required")
      .test("valid-website_link", "Enter a valid Website Link", (value) =>
        urlValidation(value),
      ),
  });

  const handleSubmit = (values) => {
    const data = {
      type: "company_about",
      ...values,
    };

    if (edittype == 1) {
      dispatch(updateProfile(data));
      setModelCompanyAbout(false);
    } else {
      setFormData((prev) => ({
        ...prev,
        ...values,
      }));
      setModelCompanyAbout((prev) => !prev);
    }
  };

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  useEffect(() => {
    if (initialValues.country_id && countrylist.length) {
      const countryIndex = countrylist?.find(item => item.id == initialValues.country_id);
      setSelectCountry({ value: countryIndex?.id, label: countryIndex?.title });
    }
  }, [countrylist]);

  const handleWorkingCountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setFieldValue("country_id", selectedOption.value);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formik) => (
        <>
          <button
            onClick={() => setModelCompanyAbout((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt="Close"
            />
          </button>
          <Form>
            <ModalBody>
              <h4>Edit Profile </h4>


              <div className="form-group">
                <label className="label-s">Company Name</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="company_name"
                  placeholder="Company Name"
                />
                <ErrorMessage
                  name="company_name"
                  component="div"
                  className="error"
                />
              </div>

              <div className="form-group">
                <label className="label-s">CR/Licensed number</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="cr_number"
                  placeholder="CR/Licensed number"
                />
                <ErrorMessage
                  name="cr_number"
                  component="div"
                  className="error"
                />
              </div>

              <div className="form-group">
                <label className="label-s">Company Website Url</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="website_link"
                  placeholder="Enter website_link"
                />
                <ErrorMessage
                  name="website_link"
                  component="div"
                  className="error"
                />
              </div>

              <div className="form-group company-document">
                <label className="label-s">  Company Document  </label>
                <CompanyFileUpload
                  formik={formik}
                  name={'about_files'}
                />
                <ErrorMessage
                  name={"about_files"}
                  component="div"
                  className="error"
                />
              </div>

              <CustomReactQuill2
                value={formik.values.about}
                setFieldValue={formik.setFieldValue}
                name={"about"}
                title={"About"}
              />
              <ErrorMessage
                name="about"
                component="div"
                className="error"
              />

              <div className="form-group">
                <label>Country of registration</label>
                <ReactSelect
                  options={
                    Array.isArray(country) &&
                    country.map((item) => ({
                      value: item.id,
                      label: item.title,
                    }))
                  }
                  placeholder="Select Country"
                  value={selectCountry}
                  onChange={(option) =>
                    handleWorkingCountryChange(option, formik)
                  }
                />
                <ErrorMessage
                  name="country_id"
                  component="div"
                  className="error"
                />
              </div>
            </ModalBody>

            <ModalFooter>
              <Button className="btn" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </>
      )}
    </Formik>
  );
}
